import React from 'react';
import { titlePaths } from '@warehouse/title/core';
import { TitleYearInputField } from '../../ui/fields/TitleYearInputField';

export function ReleaseYearField() {
	return <TitleYearInputField path={titlePaths.releaseYear} label="Release Year" forcedEditMode />;
}
